module.exports = __webpack_public_path__ + "static/media/twilio.ecc268bf.svg";